import baseApi from './RootBaseApi';
import {
  CMSFAQAdminPage,
  CreateCMSFAQItemRequest,
  GenerateCMSFAQDraftsRequest,
  PublishCMSFAQTranslationRequest,
  RollbackCMSFAQTranslationRequest,
  UpdateCMSFAQItemRequest,
  UpdateCMSFAQTranslationDraftRequest,
} from '@/types/cms.types';

interface CmsFAQAdminResponse {
  status: boolean;
  message: string;
  data: CMSFAQAdminPage;
}

export const cmsFAQApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCMSFAQAdminPage: builder.query<CmsFAQAdminResponse, void>({
      query: () => ({
        url: '/cms/faq/admin',
        method: 'GET',
      }),
      providesTags: ['CMS'],
      keepUnusedDataFor: 0,
    }),
    createCMSFAQItem: builder.mutation<
      CmsFAQAdminResponse,
      CreateCMSFAQItemRequest
    >({
      query: (body) => ({
        url: '/cms/faq/items',
        method: 'POST',
        data: body,
      }),
      invalidatesTags: ['CMS'],
    }),
    updateCMSFAQItem: builder.mutation<
      CmsFAQAdminResponse,
      UpdateCMSFAQItemRequest
    >({
      query: ({ id, ...body }) => ({
        url: `/cms/faq/items/${id}`,
        method: 'PUT',
        data: body,
      }),
      invalidatesTags: ['CMS'],
    }),
    deleteCMSFAQItem: builder.mutation<CmsFAQAdminResponse, string>({
      query: (id) => ({
        url: `/cms/faq/items/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['CMS'],
    }),
    generateCMSFAQDrafts: builder.mutation<
      CmsFAQAdminResponse,
      GenerateCMSFAQDraftsRequest
    >({
      query: ({ id, ...body }) => ({
        url: `/cms/faq/items/${id}/translations/generate`,
        method: 'POST',
        data: body,
      }),
      invalidatesTags: ['CMS'],
    }),
    updateCMSFAQTranslationDraft: builder.mutation<
      CmsFAQAdminResponse,
      UpdateCMSFAQTranslationDraftRequest
    >({
      query: ({ id, language, ...body }) => ({
        url: `/cms/faq/items/${id}/translations/${language}/draft`,
        method: 'PUT',
        data: body,
      }),
      invalidatesTags: ['CMS'],
    }),
    publishCMSFAQTranslation: builder.mutation<
      CmsFAQAdminResponse,
      PublishCMSFAQTranslationRequest
    >({
      query: ({ id, language }) => ({
        url: `/cms/faq/items/${id}/translations/${language}/publish`,
        method: 'POST',
      }),
      invalidatesTags: ['CMS'],
    }),
    rollbackCMSFAQTranslation: builder.mutation<
      CmsFAQAdminResponse,
      RollbackCMSFAQTranslationRequest
    >({
      query: ({ id, language }) => ({
        url: `/cms/faq/items/${id}/translations/${language}/rollback`,
        method: 'POST',
      }),
      invalidatesTags: ['CMS'],
    }),
  }),
});

export const {
  useGetCMSFAQAdminPageQuery,
  useCreateCMSFAQItemMutation,
  useUpdateCMSFAQItemMutation,
  useDeleteCMSFAQItemMutation,
  useGenerateCMSFAQDraftsMutation,
  useUpdateCMSFAQTranslationDraftMutation,
  usePublishCMSFAQTranslationMutation,
  useRollbackCMSFAQTranslationMutation,
} = cmsFAQApi;
